import {Component, OnInit} from '@angular/core';
import {UtilService} from '../../../../services/util.service';
import {AssetService} from '../../../../services/assets/asset.service';

@Component({
  selector: 'sb-page-repositories-edit',
  templateUrl: './repositories-edit.component.html',
  styleUrls: ['./repositories-edit.component.scss'],
  standalone: false,
})
export class RepositoriesEditComponent implements OnInit {
  constructor(
    public util: UtilService,
    public assetService: AssetService
  ) {}

  ngOnInit(): void {}
}
